<!-- /****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
@if (data?.type == 'alert') {
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div mat-dialog-content>
    <p>{{data.content}}</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
  </div>
} @else {
  @if (data?.type == 'confirm') {
    <h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content>
      <p>{{data.content}}</p>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button [mat-dialog-close]=null>No</button>
      <button mat-raised-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>Yes</button>
    </div>
  } @else {
    <ng-container>
      <h1 mat-dialog-title>{{data.title}}</h1>
      <div mat-dialog-content>
        <mat-form-field class="txtName">
          <input matInput maxLength="{{txtMaxLength}}" placeholder="{{data.content.txtPlaceHolder}}" [(ngModel)]="data.content.txtValue">
        </mat-form-field>
        <p>{{data.content.message}}</p>
      </div>
      <div mat-dialog-actions>
        <button mat-raised-button color="accent" [mat-dialog-close]=null >{{'supplier.userlist.no'| translate}}</button>
        <button mat-raised-button [mat-dialog-close]="data.content.txtValue" color="primary" cdkFocusInitial>{{'supplier.userlist.yes'| translate}}</button>
      </div>
    </ng-container>
  }
}

